import React from 'react';
import './index.css';
import FileViewer from './components/fileViewer';
import Login from './components/login';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export const theme = createTheme({
    status: {
      danger: '#e53e3e',
      error: '#96031A'
    },
    typography:{
      subtitle1:{
        fontSize:16,
        fontWeight:'bold'
      },
      body1:{
        fontSize:15
      },
      info:{
        fontSize:13
      }
    },
    palette: {
      primary: {
        main: '#255760',
        darker: '#1B3E45',
        background:'rgba(37, 87, 96,0.5)'
      },
      warning: {
        main: '#D5A021',
      },
      action:{
        hover: 'rgba(37, 87, 96, 0.1)'
      },
      neutral: {
        main: '#fff',
        contrastText: '#000',
      },
      turquoise: {
        main: '#79E1D5',
        contrastText: '#FFF'
      },
      valide: {
        main: '#5da271',
        contrastText: '#FFF'
      },
      verdigris: {
        main: '#51B2A7',
        contrastText: '#FFF'
      },
      purple: {
        main: '#BF49A5',
        contrastText: '#FFF'
      },
      carmine: {
        main: '#96031A',
        contrastText: '#FFF',
        background: 'rgba(150, 3, 26, 0.5)'
      },
      grey: {
        main: '#BCC9C7',
        contrastText: "#000"
      },
      dark: {
        main: '#000',
        contrastText: "#FFF"
      }
    },
    components:{
      MuiTableCell:{styleOverrides:{
        head: {
          backgroundColor: "#50787F",
          color: '#fff'
        },
        root:{
          fontSize:14
        }
      }},
      MuiTableRow: {styleOverrides:{
        root:{
          '&:nth-of-type(even)':{
            backgroundColor:"rgba(37, 87, 96, 0.05)"
          }
        },
      }}
    }
});

const router = createBrowserRouter([
  {path:"/", element: <FileViewer/>},
  {path:"*", element: <FileViewer/>},
])

const unloggedRouter = createBrowserRouter([
  {path:"/", element: <Login/>},
  {path:"/login", element: <Login/>},
  {path:"*", element: <Login/>},
])

export const Context = React.createContext();
export default function App() {
  const [isConnected, setIsConnected] = React.useState(Boolean(sessionStorage.getItem('token')));

  return(
    <Context.Provider value={{isConnected, setIsConnected}}>
      <ThemeProvider theme={theme}>
        <React.StrictMode>
          <RouterProvider router={isConnected?router:unloggedRouter}/>
        </React.StrictMode>
      </ThemeProvider>
    </Context.Provider>
  );

}